import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { useAtomValue } from 'jotai';
import { get as lodashGet } from 'lodash-es';
import { useCallback } from 'react';
import { sectorsByIdMapAtom, usersByIdMapAtom } from '../../../../../services/state/AppConfigStateJ';
import { useCompanyMapLookup } from '../../../../../services/hooks/useSaveCompanyData';

// maps column name to path
const colsWithUserIds = {
  dealLead: 'dealLeadId',
  internalSource: 'internalSourceId',
  boardDirector: 'boardDirectorId',
  dealTeam: 'dealTeamIds',
};

const colsWithSectorIds = {
  Sector: 'sectorId',
};

export function useColsWithIds() {
  const usersByIdMap = useAtomValue(usersByIdMapAtom);
  const sectorMap = useAtomValue(sectorsByIdMapAtom);
  const getCompany = useCompanyMapLookup();

  const getColsWithIds = useCallback(
    (columnProps: ColDef[]) => {
      return columnProps.map((column) => {
        if (column.colId && column.colId in colsWithUserIds) {
          return {
            ...column,
            valueGetter: (params: ValueGetterParams) => {
              const path = colsWithUserIds[column.colId! as keyof typeof colsWithUserIds];
              const company = getCompany(params.data?.companyId ?? -1);
              const userId = lodashGet(company, path);
              if (Array.isArray(userId)) {
                return userId.map((id) => usersByIdMap.get(id)?.name);
              } else {
                return usersByIdMap.get(userId)?.name;
              }
            },
            filter: 'agSetColumnFilter',
          };
        } else if (column.colId && column.colId in colsWithSectorIds) {
          return {
            ...column,
            valueGetter: (params: ValueGetterParams) => {
              const path = colsWithSectorIds[column.colId! as keyof typeof colsWithSectorIds];
              const company = getCompany(params.data?.companyId ?? -1);
              const sectorId = lodashGet(company, path);
              return sectorMap.get(sectorId)?.name;
            },
            filter: 'agSetColumnFilter',
          };
        } else {
          return column;
        }
      });
    },
    [getCompany, sectorMap, usersByIdMap]
  );

  return { getColsWithIds };
}
